import {Client} from '../../../graphql/types'

const IB_ID = [
  10029, 10078, 10083, 10084, 10085, 10088, 10093, 10096, 10097, 10162, 10166, 10167, 10169, 10183,
  10188, 10206, 10209, 10212, 10213, 10222, 10224, 10226, 10227, 10230, 10235, 10236, 10237, 10238,
  10244, 10246, 10248, 10249, 10258, 10268, 10270, 10272, 10274, 10275, 10276, 10279, 10281, 10289,
  10291, 10292, 10293, 10295, 10296, 10297, 10300, 10301, 10302, 10303, 10305, 10307, 10316, 10318,
  10319, 10320, 10322, 10324, 10326, 10327, 10329, 10330, 10332, 10333, 10338, 10341, 10342, 10346,
  10350, 10354, 10355, 10358, 10361, 10363, 10364, 10365, 10367, 10369, 10371, 10372, 10376, 10377,
  10381, 10382, 10389, 10390, 10391, 10392, 10400, 10401, 10402, 10403, 10404, 10407, 10408, 10409,
  10414, 10416, 10417, 10418, 10427, 10430, 10438, 10439, 10442, 10443, 10446, 10447, 10450, 10451,
  10452, 10453, 10456, 10458, 10461, 10462, 10467, 10469, 10470, 10473, 10475, 10479, 10480, 10481,
  10482, 10483, 10484, 10485, 10487, 10488, 10489, 10490, 10491, 10492, 10497, 10499, 10501, 10502,
  10503, 10504, 10505, 10506, 10507, 10510, 10511, 10515, 10517, 10520, 10521, 10522, 10545, 10530,
  10537, 36993, 37015, 10531, 10539, 10529, 10209, 10538, 10528, 10404, 10540, 10550, 10549, 10547,
]

export const overrideForIB = (accounts: any[], client: Client) => {
  if (!client.metadata) return accounts

  let metadata: any
  try {
    metadata = JSON.parse(client.metadata)
  } catch (err) {
    console.warn('Failed to parse metadata:', client.metadata)
    return accounts
  }

  const remoteIbId = metadata?.ibFollowerData?.remoteIbId

  if (!IB_ID.includes(remoteIbId)) return accounts

  return accounts.filter(
    (account) =>
      !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype) &&
      account.category !== 'affiliate',
  )
}
